/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbEvaluationDto
 */
export interface FcbEvaluationDto {
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    idEvaluation?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    typeEvaluation?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    idClasse?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    idClasseMatiere?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbEvaluationDto
     */
    anneeScolaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbEvaluationDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbEvaluationDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    coteMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    coteMaxReferentiel?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbEvaluationDto
     */
    lockFormateur?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    idParent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationDto
     */
    idEvaluationParent?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbEvaluationDto
     */
    remediation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbEvaluationDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbEvaluationDto interface.
 */
export function instanceOfFcbEvaluationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEvaluationDtoFromJSON(json: any): FcbEvaluationDto {
    return FcbEvaluationDtoFromJSONTyped(json, false);
}

export function FcbEvaluationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEvaluationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idEvaluation': !exists(json, 'idEvaluation') ? undefined : json['idEvaluation'],
        'typeEvaluation': !exists(json, 'typeEvaluation') ? undefined : json['typeEvaluation'],
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'idClasseMatiere': !exists(json, 'idClasseMatiere') ? undefined : json['idClasseMatiere'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'coteMax': !exists(json, 'coteMax') ? undefined : json['coteMax'],
        'coteMaxReferentiel': !exists(json, 'coteMaxReferentiel') ? undefined : json['coteMaxReferentiel'],
        'lockFormateur': !exists(json, 'lockFormateur') ? undefined : json['lockFormateur'],
        'idParent': !exists(json, 'idParent') ? undefined : json['idParent'],
        'idEvaluationParent': !exists(json, 'idEvaluationParent') ? undefined : json['idEvaluationParent'],
        'remediation': !exists(json, 'remediation') ? undefined : json['remediation'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbEvaluationDtoToJSON(value?: FcbEvaluationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idEvaluation': value.idEvaluation,
        'typeEvaluation': value.typeEvaluation,
        'idClasse': value.idClasse,
        'idClasseMatiere': value.idClasseMatiere,
        'anneeScolaire': value.anneeScolaire,
        'date': value.date,
        'libelle': value.libelle,
        'coteMax': value.coteMax,
        'coteMaxReferentiel': value.coteMaxReferentiel,
        'lockFormateur': value.lockFormateur,
        'idParent': value.idParent,
        'idEvaluationParent': value.idEvaluationParent,
        'remediation': value.remediation,
        'actif': value.actif,
    };
}

